module.exports = __webpack_public_path__ + "img/Icon Performance Assessment.8016b9da.svg";